// src/pages/AdminLogin.jsx
import { useNavigate } from "react-router-dom";
import LoginForm from "../components/LoginForm";

export default function AdminLogin() {
  const nav = useNavigate();

  return (
    <LoginForm
      title="管理者ログイン"
      accent="#0ea5e9"
      mode="admin"
      onSuccess={(data) => {
        console.log("📥トークン:", data);

        let targetObj = data;
        if (data && data.data) {
          targetObj = data.data;
        }
        if (targetObj && targetObj.user) {
          targetObj = targetObj.user;
        }

        const isStaff = targetObj?.is_staff === true;
        const isSuper = targetObj?.is_superuser === true;
        const perms = Array.isArray(targetObj?.permissions) ? targetObj.permissions : [];
        
        console.log(`結果: isStaff=${isStaff}, isSuper=${isSuper}, 権限=`, perms);

        const hasAdminAccess = isStaff || isSuper || perms.length > 0;

        if (!hasAdminAccess) {
          alert("管理者権限、または該当機能のアクセス権限がありません。");
          return;
        }

        console.log("🚀 権限が正しく! 画面を遷移中...");
        
        
        nav("/dashboard", { replace: true });
      }}
    />
  );
}